import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "admin-modal" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = { class: "duration-wrapper" }
const _hoisted_4 = { class: "duration-type" }
const _hoisted_5 = { class: "selected-duration-wrapper" }
const _hoisted_6 = { class: "field" }
const _hoisted_7 = {
  key: 0,
  class: "error-text"
}
const _hoisted_8 = {
  key: 0,
  class: "error-text"
}
const _hoisted_9 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('close'))),
    img: "Modal-background.png",
    name: "Block chat"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, "Block chat access for " + _toDisplayString(_ctx.username) + " for:", 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.blockDurationUnit) = $event)),
                  type: "radio",
                  value: "seconds"
                }, null, 512), [
                  [_vModelRadio, _ctx.blockDurationUnit]
                ]),
                _cache[11] || (_cache[11] = _createTextVNode(" Seconds ", -1))
              ]),
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.blockDurationUnit) = $event)),
                  type: "radio",
                  value: "minutes"
                }, null, 512), [
                  [_vModelRadio, _ctx.blockDurationUnit]
                ]),
                _cache[12] || (_cache[12] = _createTextVNode(" Minutes ", -1))
              ]),
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.blockDurationUnit) = $event)),
                  type: "radio",
                  value: "hours"
                }, null, 512), [
                  [_vModelRadio, _ctx.blockDurationUnit]
                ]),
                _cache[13] || (_cache[13] = _createTextVNode(" Hours ", -1))
              ]),
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.blockDurationUnit) = $event)),
                  type: "radio",
                  value: "days"
                }, null, 512), [
                  [_vModelRadio, _ctx.blockDurationUnit]
                ]),
                _cache[14] || (_cache[14] = _createTextVNode(" Days ", -1))
              ]),
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.blockDurationUnit) = $event)),
                  type: "radio",
                  value: "months"
                }, null, 512), [
                  [_vModelRadio, _ctx.blockDurationUnit]
                ]),
                _cache[15] || (_cache[15] = _createTextVNode(" Months ", -1))
              ]),
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.blockDurationUnit) = $event)),
                  type: "radio",
                  value: "years"
                }, null, 512), [
                  [_vModelRadio, _ctx.blockDurationUnit]
                ]),
                _cache[16] || (_cache[16] = _createTextVNode(" Years ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.blockDuration) = $event)),
                type: "number",
                min: "1",
                placeholder: "Duration"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.blockDuration,
                  void 0,
                  { number: true }
                ]
              ]),
              _createElementVNode("span", null, _toDisplayString(_ctx.blockDurationUnit), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[17] || (_cache[17] = _createElementVNode("p", null, "Reason:", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.blockReason) = $event)),
            type: "text",
            placeholder: "Why this user should be blocked?",
            onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.blockReasonRequiredMessage = ''))
          }, null, 544), [
            [_vModelText, _ctx.blockReason]
          ]),
          (_ctx.blockReasonRequiredMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("p", null, _toDisplayString(_ctx.blockReasonRequiredMessage), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.blockError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("p", null, _toDisplayString(_ctx.blockError), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Button, {
            type: "primary__white",
            size: "small",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('close')))
          }, {
            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
              _createTextVNode(" Cancel ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_Button, {
            type: "primary",
            size: "small",
            onClick: _ctx.confirm
          }, {
            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
              _createTextVNode(" Block ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }))
}